import React from "react";
import DOMPurify from "dompurify";

// Lightweight markdown renderer (headings, bold, code, lists, code-blocks)
function escapeHtml(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function render(md) {
  if (!md) return "";
  const blocks = md.split(/```/);
  let html = "";
  blocks.forEach((block, i) => {
    if (i % 2 === 1) {
      const firstNl = block.indexOf("\n");
      const code = firstNl >= 0 ? block.slice(firstNl + 1) : block;
      html += `<pre><code>${escapeHtml(code)}</code></pre>`;
    } else {
      let t = escapeHtml(block);
      t = t.replace(/^### (.*)$/gm, "<h3>$1</h3>");
      t = t.replace(/^## (.*)$/gm, "<h2>$1</h2>");
      t = t.replace(/^# (.*)$/gm, "<h1>$1</h1>");
      t = t.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
      t = t.replace(/`([^`]+?)`/g, "<code>$1</code>");
      t = t.replace(/^\s*[-*] (.*)$/gm, "<li>$1</li>");
      t = t.replace(/(<li>.*<\/li>\n?)+/g, (m) => `<ul>${m}</ul>`);
      t = t.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
      t = t
        .split(/\n{2,}/)
        .map((p) => (p.match(/^<(h\d|ul|pre|li)/) ? p : p.trim() ? `<p>${p.replace(/\n/g, "<br/>")}</p>` : ""))
        .join("");
      html += t;
    }
  });
  return html;
}

export default function Markdown({ children }) {
  const clean = DOMPurify.sanitize(render(children || ""), { ADD_ATTR: ["target", "rel"] });
  return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: clean }} />;
}
